import { useCallback, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import queryString from 'query-string';

export const useQueryParams = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const queryParams = useMemo(() => {
    const params = queryString.parse(search);
    if (typeof params.locationIds === 'string') {
      return { ...params, locationIds: params.locationIds.split(',') };
    }

    return params;
  }, [search]);

  const updateQueryParams = useCallback(
    newValues => {
      const newParams = queryString.stringify(
        {
          ...queryParams,
          ...newValues.reduce((acc, currentValue) => {
            acc[currentValue.name] = currentValue.value || null;

            return acc;
          }, queryParams),
        },
        { arrayFormat: 'comma', encode: false, skipNull: true }
      );

      navigate(`?${newParams}`);
    },

    [navigate, queryParams]
  );

  return {
    queryParams,
    updateQueryParams,
  };
};
